<div class="flex h-screen items-center justify-center">
	<div class="w-85 space-y-5 rounded bg-white p-6 drop-shadow-md">
		<img ngSrc="/images/logo_round_small.png" alt="Somerville Logo" height="35" class="mx-auto mb-4" width="35" />
		<div class="text-center">
			<h1 class="text-lg font-medium text-gray-700">Somerville Requisitions</h1>
			<p class="mt-1 text-xs font-medium tracking-[0.22em] text-gray-400 uppercase">KIOSK SIGN IN</p>
		</div>
		<app-kiosk-sign-in-form></app-kiosk-sign-in-form>
	</div>
</div>
